import { getPaddingString, toRGBA } from "../parser/utils";
import { CLOCK_ACT_HEIGHT, CLOCK_ACT_WIDTH } from "./Countdown";

export function calculateTimeDifference(endDateTimestamp) {
  const endDate = new Date(+endDateTimestamp);
  const now = new Date();
  const difference = endDate - now;

  const days = Math.floor(difference / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((difference % (1000 * 60)) / 1000);

  const datetimeUnits = {
    minutes: minutes >= 0 ? minutes.toString().padStart(2, "0") : "00",
    seconds: seconds >= 0 ? seconds.toString().padStart(2, "0") : "00",
  };

  if (days > 0) {
    datetimeUnits.showDays = true;
    datetimeUnits.days = days.toString().padStart(2, "0");
  }

  if (days > 0 || hours > 0) {
    datetimeUnits.showHours = true;
    datetimeUnits.hours = hours.toString().padStart(2, "0");
  }

  return datetimeUnits;
}

export function calculateFutureTime(days = 0, hours = 0, minutes = 0) {
  const daysInMilliseconds = days * 24 * 60 * 60 * 1000;
  const hoursInMilliseconds = hours * 60 * 60 * 1000;
  const minutesInMilliseconds = minutes * 60 * 1000;
  const totalMilliseconds =
    daysInMilliseconds + hoursInMilliseconds + minutesInMilliseconds;
  return new Date().getTime() + totalMilliseconds;
}

function setCookie(name, value, timestamp) {
  var expires = "";
  if (timestamp) {
    var date = new Date();
    date.setTime(timestamp);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  let matches = document.cookie.match(
    new RegExp(
      "(?:^|; )" +
        name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$&") +
        "=([^;]*)"
    )
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

const simpleText = ({
  datetimeUnits,
  labelColor,
  hideLabel,
  labelArr,
  shortId,
  computedTimestamp,
  autoSize,
  clockWidth,
  paddingLeft,
  paddingRight,
  timeEndAnimation,
  days, hours, minutes,
  dateType,
}) => {

  const labelStyle = `color: ${toRGBA(labelColor)};display: ${hideLabel ? "none" : "block"};`;

  let daysStr = "";
  if (datetimeUnits.showDays) {
    daysStr = `
      <div class="rip-mm-cd-text-group">
        <div class="rip-mm-cd-text-container">
          <div class="rip-mm-cd-text d1">${datetimeUnits.days[0]}</div>
          <div class="rip-mm-cd-text d2">${datetimeUnits.days[1]}</div>
        </div>
        <div style="${labelStyle}" class="rim-mm-cd-label">
          ${labelArr[0]}
        </div>
      </div>
    `;
  }

  let hoursStr = "";
  if (datetimeUnits.showHours) {
    hoursStr = `
      <div class="rip-mm-cd-text-group">
        <div class="rip-mm-cd-text-container">
          <div class="rip-mm-cd-text h1">${datetimeUnits.hours[0]}</div>
          <div class="rip-mm-cd-text h2 cd-colon">${datetimeUnits.hours[1]}</div>
        </div>
        <div style="${labelStyle}" class="rim-mm-cd-label">
          ${labelArr[0]}
        </div>
      </div>
    `;
  }

  return `
    <div id="${shortId}" style="color: ${toRGBA(labelColor)};" class="rip-mm-cd-wrapper face-text">
      ${daysStr}
      ${hoursStr}
      <div class="rip-mm-cd-text-group">
        <div class="rip-mm-cd-text-container">
          <div class="rip-mm-cd-text m1">${datetimeUnits.minutes[0]}</div>
          <div class="rip-mm-cd-text m2 cd-colon">${datetimeUnits.minutes[1]}</div>
        </div>
        <div style="${labelStyle}" class="rim-mm-cd-label">
          ${labelArr[2]}
        </div>
      </div>
      <div class="rip-mm-cd-text-group">
        <div class="rip-mm-cd-text-container">
          <div class="rip-mm-cd-text s1">${datetimeUnits.seconds[0]}</div>
          <div class="rip-mm-cd-text s2">${datetimeUnits.seconds[1]}</div>
        </div>
        <div style="${labelStyle}" class="rim-mm-cd-label">
          ${labelArr[3]}
        </div>
      </div>
      <script>
        (function() {
          var pid = setInterval(function () {
            let computedTimestamp = ${computedTimestamp}

            const cookieName = 'rip-cd-${shortId}-${days || 0}-${hours || 0}-${minutes || 0}';
            if ('${dateType}' === "variable") {
              let endTimestamp = getCookie(cookieName);
              if (!endTimestamp) {
                endTimestamp = calculateFutureTime(${days}, ${hours}, ${minutes});
                setCookie(
                  cookieName,
                  endTimestamp,
                  endTimestamp,
                );
              }
              computedTimestamp = endTimestamp;
            }

            const obj = calculateTimeDifference(computedTimestamp);
            textCountdown("${shortId}", obj);
            const parentWidth = $("#${shortId}").closest(".rip-mm-col").width();
            let scaleRate = .1;

            if (parentWidth) {
              if (${autoSize}) {
                scaleRate =
                  (parentWidth - ${paddingLeft} - ${paddingRight}) / ${CLOCK_ACT_WIDTH};
              } else {
                scaleRate = ${clockWidth} / ${CLOCK_ACT_WIDTH};
              }
            }
            $("#${shortId}").closest(".rim-mm-cd-scale")
              .css("transform", "scale(" + scaleRate + ")")
              .css("height", ${(hideLabel ? CLOCK_ACT_HEIGHT - 22 : CLOCK_ACT_HEIGHT)} * scaleRate);
            if (Date.now() > computedTimestamp) {
                $("#${shortId}").addClass("animate__animated animate__${timeEndAnimation}") 
                $(".rip-mm-submit-btn.submit").hide();
                $(".rip-mm-submit-btn.reset").hide();
            } else {
              $(".rip-mm-submit-btn.submit").show();
              $(".rip-mm-submit-btn.reset").show();
            }

            console.log("running");
          }, 1000);
          pendingIntervalIds.push(pid);
        })();
      </script>
    </div>
  `;
};

const flipCard = ({
  shortId,
  labelColor,
  cardColor,
  hideLabel,
  labelArr,
  datetimeUnits,
  computedTimestamp,
  autoSize,
  clockWidth,
  paddingLeft,
  paddingRight,
  timeEndAnimation,
  days, hours, minutes,
  dateType,
}) => {
  let daysStr = "";
  const cardStyle = `color: ${toRGBA(labelColor)};background-color: ${toRGBA(
    cardColor
  )}`;
  const labelStyle = `color: ${toRGBA(cardColor)};display: ${
    hideLabel ? "none" : "block"
  }`;
  if (datetimeUnits.showDays) {
    daysStr = `
      <div class="rip-mm-cd-group">
        <div class="rip-mm-cd-flip-container">
          <ul class="rip-mm-cd-flip d1">
            <li class="rip-mm-cd-aa">
              <div class="up">
                <div class="shadow"></div>
                <div style="${cardStyle}" class="inn">${datetimeUnits.days[0]}</div>
              </div>
              <div class="down">
                <div class="shadow"></div>
                <div style="${cardStyle}" class="inn">${datetimeUnits.days[0]}</div>
              </div>
            </li>
            <li class="rip-mm-cd-bb">
              <div class="up">
                <div class="shadow"></div>
                <div style="${cardStyle}" class="inn">${datetimeUnits.days[0]}</div>
              </div>
              <div class="down">
                <div class="shadow"></div>
                <div style="${cardStyle}" class="inn">${datetimeUnits.days[0]}</div>
              </div>
            </li>
          </ul>

          <ul class="rip-mm-cd-flip d2">
            <li class="rip-mm-cd-aa">
              <div class="up">
                <div class="shadow"></div>
                <div style="${cardStyle}" class="inn">${datetimeUnits.days[1]}</div>
              </div>
              <div class="down">
                <div class="shadow"></div>
                <div style="${cardStyle}" class="inn">${datetimeUnits.days[1]}</div>
              </div>
            </li>
            <li class="rip-mm-cd-bb">
              <div class="up">
                <div class="shadow"></div>
                <div style="${cardStyle}" class="inn">${datetimeUnits.days[1]}</div>
              </div>
              <div class="down">
                <div class="shadow"></div>
                <div style="${cardStyle}" class="inn">${datetimeUnits.days[1]}</div>
              </div>
            </li>
          </ul>
        </div>
        <div
          style="${labelStyle}"
          class="rim-mm-cd-label"
        >
          ${labelArr[0]}
        </div>
      </div>
    `;
  }

  let hoursStr = "";
  if (datetimeUnits.showHours) {
    hoursStr = `
      <div class="rip-mm-cd-group">
        <div class="rip-mm-cd-flip-container">
          <ul class="rip-mm-cd-flip h1">
            <li class="rip-mm-cd-aa">
              <div class="up">
                <div class="shadow"></div>
                <div style="${cardStyle}" class="inn">${datetimeUnits.hours[0]}</div>
              </div>
              <div class="down">
                <div class="shadow"></div>
                <div style="${cardStyle}" class="inn">${datetimeUnits.hours[0]}</div>
              </div>
            </li>
            <li class="rip-mm-cd-bb">
              <div class="up">
                <div class="shadow"></div>
                <div style="${cardStyle}" class="inn">${datetimeUnits.hours[0]}</div>
              </div>
              <div class="down">
                <div class="shadow"></div>
                <div style="${cardStyle}" class="inn">${datetimeUnits.hours[0]}</div>
              </div>
            </li>
          </ul>
          <ul class="rip-mm-cd-flip h2">
            <li class="rip-mm-cd-aa">
              <div class="up">
                <div class="shadow"></div>
                <div style="${cardStyle}" class="inn">${datetimeUnits.hours[1]}</div>
              </div>
              <div class="down">
                <div class="shadow"></div>
                <div style="${cardStyle}" class="inn">${datetimeUnits.hours[1]}</div>
              </div>
            </li>
            <li class="rip-mm-cd-bb">
              <div class="up">
                <div class="shadow"></div>
                <div style="${cardStyle}" class="inn">${datetimeUnits.hours[1]}</div>
              </div>
              <div class="down">
                <div class="shadow"></div>
                <div style="${cardStyle}" class="inn">${datetimeUnits.hours[1]}</div>
              </div>
            </li>
          </ul>
        </div>
        <div
          style="${labelStyle}"
          class="rim-mm-cd-label"
        >
          ${labelArr[1]}
        </div>
      </div>
    `;
  }

  return `
    <div class="rip-mm-cd-wrapper" id="${shortId}">
    ${daysStr}
    ${hoursStr}
    <div class="rip-mm-cd-group">
      <div class="rip-mm-cd-flip-container">
        <ul class="rip-mm-cd-flip m1">
          <li class="rip-mm-cd-aa">
            <div class="up">
              <div class="shadow"></div>
              <div style="${cardStyle}" class="inn">${datetimeUnits.minutes[0]}</div>
            </div>
            <div class="down">
              <div class="shadow"></div>
              <div style="${cardStyle}" class="inn">${datetimeUnits.minutes[0]}</div>
            </div>
          </li>
          <li class="rip-mm-cd-bb">
            <div class="up">
              <div class="shadow"></div>
              <div style="${cardStyle}" class="inn">${datetimeUnits.minutes[0]}</div>
            </div>
            <div class="down">
              <div class="shadow"></div>
              <div style="${cardStyle}" class="inn">${datetimeUnits.minutes[0]}</div>
            </div>
          </li>
        </ul>

        <ul class="rip-mm-cd-flip m2">
          <li class="rip-mm-cd-aa">
            <div class="up">
              <div class="shadow"></div>
              <div style="${cardStyle}" class="inn">${datetimeUnits.minutes[1]}</div>
            </div>
            <div class="down">
              <div class="shadow"></div>
              <div style="${cardStyle}" class="inn">${datetimeUnits.minutes[1]}</div>
            </div>
          </li>
          <li class="rip-mm-cd-bb">
            <div class="up">
              <div class="shadow"></div>
              <div style="${cardStyle}" class="inn">${datetimeUnits.minutes[1]}</div>
            </div>
            <div class="down">
              <div class="shadow"></div>
              <div style="${cardStyle}" class="inn">${datetimeUnits.minutes[1]}</div>
            </div>
          </li>
        </ul>
      </div>
      <div
        style="${labelStyle}"
        class="rim-mm-cd-label"
      >
        ${labelArr[2]}
      </div>
    </div>

    <div class="rip-mm-cd-group">
      <div class="rip-mm-cd-flip-container">
        <ul class="rip-mm-cd-flip s1">
          <li class="rip-mm-cd-aa">
            <div class="up">
              <div class="shadow"></div>
              <div style="${cardStyle}" class="inn">${datetimeUnits.seconds[0]}</div>
            </div>
            <div class="down">
              <div class="shadow"></div>
              <div style="${cardStyle}" class="inn">${datetimeUnits.seconds[0]}</div>
            </div>
          </li>
          <li class="rip-mm-cd-bb">
            <div class="up">
              <div class="shadow"></div>
              <div style="${cardStyle}" class="inn">${datetimeUnits.seconds[0]}</div>
            </div>
            <div class="down">
              <div class="shadow"></div>
              <div style="${cardStyle}" class="inn">${datetimeUnits.seconds[0]}</div>
            </div>
          </li>
        </ul>

        <ul class="rip-mm-cd-flip s2">
          <li class="rip-mm-cd-aa">
            <div class="up">
              <div class="shadow"></div>
              <div style="${cardStyle}" class="inn">${datetimeUnits.seconds[1]}</div>
            </div>
            <div class="down">
              <div class="shadow"></div>
              <div style="${cardStyle}" class="inn">${datetimeUnits.seconds[1]}</div>
            </div>
          </li>
          <li class="rip-mm-cd-bb">
            <div class="up">
              <div class="shadow"></div>
              <div style="${cardStyle}" class="inn">${datetimeUnits.seconds[1]}</div>
            </div>
            <div class="down">
              <div class="shadow"></div>
              <div style="${cardStyle}" class="inn">${datetimeUnits.seconds[1]}</div>
            </div>
          </li>
        </ul>
      </div>
      <div
        style="${labelStyle}"
        class="rim-mm-cd-label"
      >
        ${labelArr[3]}
      </div>
    </div>
  </div>
  <script>
    (function() {
      setCookie('rip-cd-${shortId}-${days || 0}-${hours || 0}-${minutes || 0}', 0, 0,);
    })();
    (function() {
      var pid = setInterval(function () {
        let computedTimestamp = ${computedTimestamp}

        const cookieName = 'rip-cd-${shortId}-${days || 0}-${hours || 0}-${minutes || 0}';
        if ('${dateType}' === "variable") {
          let endTimestamp = getCookie(cookieName);
          if (!endTimestamp) {
            endTimestamp = calculateFutureTime(${days}, ${hours}, ${minutes});
            setCookie(
              cookieName,
              endTimestamp,
            );
          }
          computedTimestamp = endTimestamp;
        }

        const obj = calculateTimeDifference(computedTimestamp);
        flipCountdown("${shortId}", obj);

        const parentWidth = $("#${shortId}").closest(".rip-mm-col").width();
        let scaleRate = .1;

        if (parentWidth) {
          if (${autoSize}) {
            scaleRate =
              (parentWidth - ${paddingLeft} - ${paddingRight}) / ${CLOCK_ACT_WIDTH};
          } else {
            scaleRate = ${clockWidth} / ${CLOCK_ACT_WIDTH};
          }
        }
        $("#${shortId}").closest(".rim-mm-cd-scale")
          .css("transform", "scale(" + scaleRate + ")")
          .css("height", ${(hideLabel ? CLOCK_ACT_HEIGHT - 22 : CLOCK_ACT_HEIGHT)} * scaleRate);

        if (Date.now() > computedTimestamp) {
          $("#${shortId}").addClass("animate__animated animate__${timeEndAnimation}")
          $(".rip-mm-submit-btn.submit").hide();
          $(".rip-mm-submit-btn.reset").hide();
        } else {
          $(".rip-mm-submit-btn.submit").show();
          $(".rip-mm-submit-btn.reset").show();
        }

        console.log("running");
      }, 1000);
      pendingIntervalIds.push(pid);
    })();

  </script>
  `
}

export default ({ data, id }) => {
  const {
    fixedDate,
    dateType,
    days,
    hours,
    minutes,
    hideLabel,
    labelColor,
    cardColor,
    labelFormat,
    clockFace,
    clockWidth,
    paddingRight = 0,
    paddingLeft = 0,
    timeEndAnimation,
    autoSize,
  } = data;
  let computedTimestamp = fixedDate;
  const shortId = id.split("-")[0];
  if (dateType === "variable") {
    let endTimestamp = getCookie(
      `rip-cd-${shortId}-${days}-${hours}-${minutes}`
    );
    if (!endTimestamp) {
      endTimestamp = calculateFutureTime(days, hours, minutes);
      setCookie(
        `rip-cd-${shortId}-${days}-${hours}-${minutes}`,
        endTimestamp,
        endTimestamp,
      );
    }
    computedTimestamp = endTimestamp;
  }

  const datetimeUnits = calculateTimeDifference(computedTimestamp);
  const labelArr = labelFormat.split("-");
  return `
    <div style="${getPaddingString(data)}">
      <div
        class="rim-mm-cd-scale"
        style="transform-origin: top;transform:scale(.1);"
      >
        ${clockFace === "text" ?
          simpleText({
            datetimeUnits,
            hideLabel,
            labelArr,
            shortId,
            computedTimestamp,
            labelColor,
            clockWidth,
            autoSize,
            paddingLeft,
            paddingRight,
            timeEndAnimation,
            days, hours, minutes,
            dateType,
          }):
          flipCard({
            shortId,
            datetimeUnits,
            hideLabel,
            cardColor,
            labelColor,
            labelArr,
            computedTimestamp,
            clockWidth,
            autoSize,
            paddingLeft,
            paddingRight,
            timeEndAnimation,
            days, hours, minutes,
            dateType
          })}
      </div>
    </div>
  `;
};
